export default {
  // Settings Page
  PunchBoardTitle: "Punch Board - Game Settings",
  candidatesLabel: "Candidates List",
  candidatesPlaceholder: "Enter candidate names separated by line breaks or commas (,), press Enter to add items, maximum 20 candidates",
  candidateExists: "Candidate already exists",
  maxCandidates: "Maximum number of candidates reached (20)",
  clearSettings: "Clear Settings",
  saveSettings: "Save Settings",
  unsubmittedWarning: "Unsubmitted items found in the input field. Please confirm and press Enter before saving!"
}